/** PLP */


const $C = (el) => document.querySelector(el);
const refinementBar = $C('#refinement-bar');

function toggleFilters() {
    refinementBar.classList.toggle('refinement-bar--show');
}